import { render, staticRenderFns } from "./InternationalArchitectureAwardForm.vue?vue&type=template&id=68b88c9c"
import script from "./InternationalArchitectureAwardForm.vue?vue&type=script&lang=js"
export * from "./InternationalArchitectureAwardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b88c9c')) {
      api.createRecord('68b88c9c', component.options)
    } else {
      api.reload('68b88c9c', component.options)
    }
    module.hot.accept("./InternationalArchitectureAwardForm.vue?vue&type=template&id=68b88c9c", function () {
      api.rerender('68b88c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/international-architecture-award/components/InternationalArchitectureAwardForm.vue"
export default component.exports